import { render, staticRenderFns } from "./ConfirmMail.vue?vue&type=template&id=5324d1b8&scoped=true&"
import script from "./ConfirmMail.vue?vue&type=script&lang=ts&"
export * from "./ConfirmMail.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmMail.vue?vue&type=style&index=0&id=5324d1b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5324d1b8",
  null
  
)

export default component.exports